export const useFetchDownload = () => {

  function fetchDownload(url) {
    const link = document.createElement("a");
    link.href = url;
    const filename = decodeURIComponent(new URL(url).pathname.split("/").pop());
    link.setAttribute("download", filename);

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    return { url, filename };
  };

  return fetchDownload;
};

export default useFetchDownload;
